import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "border-b border-black-300 py-16" }
const _hoisted_2 = { class: "flex w-full items-center pb-16" }
const _hoisted_3 = { class: "mr-16" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "flex flex-1 flex-col" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-14 font-medium" }
const _hoisted_8 = { class: "mt-8 flex flex-col gap-y-4" }
const _hoisted_9 = { class: "flex items-center text-12 text-black-600" }
const _hoisted_10 = { class: "ml-auto mt-12 flex items-center gap-x-8" }
const _hoisted_11 = { class: "flex items-baseline gap-x-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-12 text-black-400"
}
const _hoisted_13 = { name: "add" }
const _hoisted_14 = ["name"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_image, {
          lazyloaded: "",
          source: $props.item.image,
          class: "h-[6.375rem] w-[4.815rem] object-cover"
        }, null, 8, ["source"]),
        _createElementVNode("button", {
          class: "btn-accent btn-xsmall m-auto pt-2",
          onClickOnce: _cache[0] || (_cache[0] = $event => ($options.editKit())),
          textContent: _toDisplayString($data.locale.edit_kit)
        }, null, 40, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        ($data.locale.deliverable_at in $props.item.properties)
          ? (_openBlock(), _createElementBlock("small", {
              key: 0,
              class: "mb-4 text-[0.6875rem] tracking-wide",
              style: _normalizeStyle(`color: ${$data.unavailableProductColor}`)
            }, _toDisplayString($data.locale.deliverable_at) + " " + _toDisplayString($props.item.properties[`${$data.locale.deliverable_at}`]), 5))
          : (_openBlock(), _createElementBlock("small", {
              key: 1,
              class: "mb-4 text-[0.6875rem] tracking-wide",
              style: _normalizeStyle(`color: ${$data.availableProductColor}`)
            }, _toDisplayString($data.locale.available_now), 5)),
        _createElementVNode("a", {
          href: $props.item.url
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString($props.item.title), 1)
        ], 8, _hoisted_6),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.components, (component) => {
            return (_openBlock(), _createElementBlock("div", {
              key: component[0].key,
              class: "flex items-center gap-x-8"
            }, [
              _createVNode(_component_v_image, {
                lazyloaded: "",
                source: component[0].image,
                class: "h-64 w-48 object-cover"
              }, null, 8, ["source"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(component.length) + "x " + _toDisplayString(component[0].product_title), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            ($options.compareAtPrice > $options.price)
              ? (_openBlock(), _createElementBlock("del", _hoisted_12, _toDisplayString($options.compareAtPrice), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["text-14 font-medium", $data.skeletonClass])
            }, _toDisplayString($options.price), 3)
          ]),
          _createElementVNode("form", {
            ref: "deleteKitForm",
            class: "h-22",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers($event => ($options.deleteKit($event)), ["prevent"]))
          }, [
            _createElementVNode("button", _hoisted_13, [
              _createVNode(_component_v_icon, {
                icon: "trash",
                width: 18,
                height: 18,
                color: "#605F5F"
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$props.item, ...$props.item.components], ({key}, index) => {
              return (_openBlock(), _createElementBlock("input", {
                key: index,
                type: "hidden",
                name: `updates[${key}]`,
                value: 0
              }, null, 8, _hoisted_14))
            }), 128))
          ], 544)
        ])
      ])
    ])
  ]))
}